import styled from "@mui/styled-engine-sc";
// import { palette } from "../../../../themes/color-palette";

export const StyledFormRdvStore = styled("div")`
  ${({ theme }) => `

  `}
`;
